import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { set } from "lodash";

const initTutorialState = (id, state) => {
  if (!state[id]) {
    state[id] = {
      isOpen: false,
      currentTutorialStep: 0,
      currentTutorialSubStep: 0,
      tutorialStartTime: null,
      enteredInputs: {},
    };
  }
};

const TutorialSlicer = createSlice({
  name: "tutorials",
  initialState: {},
  reducers: {
    initTutorial: (state, action) => {
      const { tutorialId } = action.payload;
      initTutorialState(tutorialId, state);
    },
    changeTutorialOpenState: (state, action) => {
      const { tutorialId, isOpen } = action.payload;
      if (state[tutorialId]) {
        state[tutorialId].isOpen = isOpen;
        state[tutorialId].tutorialStartTime = isOpen ? dayjs() : null;
      }
    },
    goToNextStage: (state, action) => {
      const { nextStageID } = action.payload;
      initTutorialState(nextStageID, state);
      state[nextStageID].isOpen = true;
    },
    goToNextTutorialStep: (state, action) => {
      const { tutorialId, allSteps } = action.payload;
      const tutorial = state[tutorialId];
      if (!tutorial || !allSteps) return;

      const stepKeys = Object.keys(allSteps);
      const stepIndex = tutorial.currentTutorialStep;
      const subStepIndex = tutorial.currentTutorialSubStep;

      const currentStepId = stepKeys[stepIndex];
      const currentSubSteps = allSteps[currentStepId];

      const isLastSubStep = subStepIndex === currentSubSteps.length - 1;
      const isLastMainStep = stepIndex === stepKeys.length - 1;

      if (!isLastSubStep) {
        tutorial.currentTutorialSubStep += 1;
      } else if (!isLastMainStep) {
        tutorial.currentTutorialStep += 1;
        tutorial.currentTutorialSubStep = 0;
      } else {
        tutorial.currentTutorialStep = 0;
        tutorial.currentTutorialSubStep = 0;
        tutorial.isOpen = false;
        tutorial.tutorialStartTime = null;
        tutorial.enteredInputs = {};
      }
    },

    goToPreviousTutorialStep: (state, action) => {
      const { tutorialId, allSteps } = action.payload;
      const tutorial = state[tutorialId];
      if (!tutorial || !allSteps) return;

      const stepKeys = Object.keys(allSteps);
      const stepIndex = tutorial.currentTutorialStep;
      const subStepIndex = tutorial.currentTutorialSubStep;

      const isFirstMainStep = stepIndex === 0;
      const isFirstSubStep = subStepIndex === 0;

      if (!isFirstSubStep) {
        tutorial.currentTutorialSubStep -= 1;
      } else if (!isFirstMainStep) {
        const prevStepIndex = stepIndex - 1;
        const prevStepId = stepKeys[prevStepIndex];
        const prevSubSteps = allSteps[prevStepId];

        tutorial.currentTutorialStep = prevStepIndex;
        tutorial.currentTutorialSubStep = prevSubSteps.length - 1;
      } else {
        tutorial.isOpen = false;
        tutorial.tutorialStartTime = null;
        tutorial.enteredInputs = {};
      }
    },
    setEnteredInput: (state, action) => {
      const { tutorialId, inputName, value } = action.payload;
      if (state[tutorialId]) {
        set(state[tutorialId].enteredInputs, inputName, value);
      }
    },
  },
});

export const {
  initTutorial,
  goToNextStage,
  changeTutorialOpenState,
  goToNextTutorialStep,
  goToPreviousTutorialStep,
  setEnteredInput,
} = TutorialSlicer.actions;

export default TutorialSlicer.reducer;
